<template>
  <div class="animated fadeIn" v-if="$auth.check(['dashboard.accounts'])" id="coupons">
    <div v-if="loading" class="overlay">
      <div><img class="spinner" src="loading.gif" alt="Loading data..."></div>
    </div>
    <h1>Cupões</h1>

    <div id="movpoints">
      <div class="card-list">
        <div v-for="(coupon, index) in coupons" :key="index" class="card" v-if="isCouponValid(coupon.valid_date)">
          <div class="card-content">
            <span class="upper small-title">Hellmann's {{ coupon.year }}</span>
            <div class="code-container">
              <p class="ym">Código {{ coupon.date }}</p>
              <button class="copy-button" @click="copyCode(index, coupon.code)">
                {{ visibleCodes.includes(index) ? coupon.code : "Ver código" }}
              </button>
            </div>
            <div class="code-container">
              <p class="tm">{{ coupon.value }} euros</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="redencao-text">
      <div class="container">
        <h2 style="font-size: 18px;">Para redimir clique <a style="color:#fff;text-decoration: underline;" href="https://promocode.pt/code" target="_blank">aqui</a></h2>
        <br><br>
        <div class="flex-container-emissao">
          <div class="text">Instruções para a redenção:</div>
          <button class="btn icon-button" @click="showPopup = true">
            <img src="img/submit_button.png" alt="Submeter" class="icon-size">
          </button>
        </div>
        <ul></ul>
      </div>
    </div>

    <!-- ✅ Popup Overlay -->
    <div v-if="showPopup" class="popup-overlay" @click.self="showPopup = false">
      <div class="popup">
        <h3>Instruções</h3>
        <ol>
          <li>Clique em “Ver vale” para visualizar o código e poder copiar o mesmo. Será copiado automaticamente pelo sistema ou pode copiá-lo manualmente.</li>
          <li>Carregue em “Clique aqui”.</li>
          <li>Será redirecionado para a página promo code.</li>
          <li>Na página promo code, insira/cole o código (pressionando dentro do retângulo o código aparecerá) ou cole o código manualmente e a seguir clique em “Selecionar prémio”.</li>
          <li>Será redirecionado para a página dos prémios onde pode escolher uma das opções disponíveis.</li>
        </ol>
        <button @click="showPopup = false">Fechar</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      coupons: [],
      loading: true,
      visibleCodes: [],
      showPopup: false
    };
  },
  async mounted() {
    await this.fetchCouponData();
  },
  methods: {
    async fetchCouponData() {
      this.axios.get('app/getVales')
        .then(response => {
          const prizesData = response.data.prizes;
          this.coupons = prizesData.map(prize => ({
            code: prize.notes,
            date: new Date(prize.date).toLocaleString('pt-PT', { month: 'long' }).replace(/^./, str => str.toUpperCase()),
            year: new Date(prize.date).getFullYear(),
            value: prize.prizes,
            valid_date: prize.valid_date
          }));
          this.loading = false;
        })
        .catch(error => {
          this.error = error.message;
          this.loading = false;
        });
    },
    copyCode(index, code) {
      navigator.clipboard.writeText(code).then(() => {
        if (!this.visibleCodes.includes(index)) {
          this.visibleCodes.push(index);
        }
      });
    },
    isCouponValid(validDate) {
      return new Date(validDate) >= new Date();
    }
  }
}
</script>

<style>
#coupons .text {
  flex-grow: 1;
  text-align: left;
  color: #fff;
  font-size: 18px;
}

.flex-container-emissao {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-left: 0px;
}

#coupons .redencao-text {
  background: linear-gradient(240.74deg, #C26E00 0%, #AF3F00 100%);
  border-radius: 15px;
  padding-top: 20px;
  padding-left: 5px;
  padding-right: 5px;
  color: #fff;
}

#coupons h1 {
  font-size: 18px;
  text-align: left;
  text-transform: uppercase;
}

#coupons .small-title {
  font-weight: 700;
  font-size: 18px;
  line-height: 100%;
}

#coupons .copy-button {
  margin-bottom: 0px;
  background-color: rgb(244, 140, 79);
  color: white;
  padding: 12px;
  border-radius: 10px;
  max-width: 75%;
}

#movpoints .tm {
  color: #000000;
  font-size: 18px;
  font-weight: 700;
}

.code-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.copy-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 5px 10px;
  font-size: 14px;
  border-radius: 5px;
  cursor: pointer;
  white-space: nowrap;
}

.copy-button:hover {
  background-color: #0056b3;
}

#movpoints .card-list {
  display: block;
  width: 100%;
}

#movpoints .card {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px;
  background-color: #f9f9f9;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

#movpoints .card-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

#movpoints .ym {
  color: #000;
  font-weight: 500;
  font-size: 18px;
}

.dropdown-list-select {
  background-color: white;
  border: 1px solid #F48C4F !important;
  border-radius: 12px;
  max-height: 200px;
  overflow-y: auto;
  font-size: 18px;
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  max-width: 400px;
  width: 90%;
  color: #333;
}

.popup h3 {
  margin-top: 0;
}

.popup button {
  background: #F48C4F;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  margin-top: 15px;
  cursor: pointer;
}
</style>
